import { render, staticRenderFns } from "./RoomStatusDetailSpecialServiceTab.vue?vue&type=template&id=e4da4a60"
import script from "./RoomStatusDetailSpecialServiceTab.vue?vue&type=script&lang=js"
export * from "./RoomStatusDetailSpecialServiceTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports